var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 512,
    viewBox: "0 0 474 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.14 50.5H79.98C43.572 50.5 11.5 76.952 11.5 113.36V393.52C11.5 429.928 43.572 462.5 79.98 462.5H253.446C253.121 408.5 253.523 348.366 253.261 296.113C242.197 296.001 231.123 295.429 220.059 295.259C220.1 276.792 220.076 257.942 220.083 239.478C231.14 239.341 242.204 239.315 253.261 239.21C253.599 221.253 252.923 203.185 253.615 185.244C254.718 171.039 260.134 156.681 270.755 146.867C283.614 134.628 301.897 130.47 319.142 129.955C337.375 129.792 355.61 129.879 373.852 129.887C373.924 149.127 373.924 168.369 373.844 187.609C362.055 187.589 350.259 187.632 338.47 187.584C331.002 187.117 323.325 192.782 321.966 200.193C321.789 213.068 321.902 225.95 321.909 238.821C339.194 238.894 356.486 238.801 373.771 238.865C372.507 257.494 370.19 276.033 367.486 294.502C352.214 294.639 336.932 296.016 321.668 296.104C321.539 348.34 321.708 408.499 321.575 462.499H360.139C396.547 462.499 423.499 429.927 423.499 393.519V113.36C423.5 76.952 396.548 50.5 360.14 50.5Z",
    fill: "#FCFFFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(-38)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.c4d9bdc5bb242098c131fa454ab03646.svg";
export { ForwardRef as ReactComponent };